import { useQuery } from '@tanstack/react-query';
import {
  getPurchaseRequests, type PurchaseRequestFilters 
} from '../api';

export function usePurchaseRequests(filters?: PurchaseRequestFilters) {
  return useQuery({
    queryKey: ['purchaseRequests', filters],
    queryFn: () => getPurchaseRequests(filters),
    staleTime: 30_000,
  });
}
